import { c as _c } from "react/compiler-runtime";
import { Box, Breadcrumb, HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import React from 'react';
import { LuIndentIncrease } from 'react-icons/lu';
import { MdOutlineMenu } from 'react-icons/md';
import { PiChatCircleTextBold } from 'react-icons/pi';
type MembersToolbarProps = {};
export const MembersToolbar = props => {
  const $ = _c(28);
  const layout = useParentAppLayout();
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== layout) {
    t0 = layout.getPanel("members-nav");
    $[0] = layout;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isNavPanelOpen = t0.isPanelOpen;
  let t1;
  if ($[2] !== layout) {
    t1 = layout.getPanel("members-aside");
    $[2] = layout;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isAsidePanelOpen = t1.isPanelOpen;
  const t2 = isNavPanelOpen ? "colorPalette.subtle" : "colorPalette.bg/50";
  const t3 = isNavPanelOpen ? "ghost" : "solid";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      bgColor: "colorPalette.bg/50"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== layout) {
    t5 = () => {
      layout.togglePanel("members-nav");
    };
    $[5] = layout;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isNavPanelOpen) {
    t6 = !isNavPanelOpen ? <Icon asChild={true} boxSize={4} color="white"><MdOutlineMenu /></Icon> : <Icon asChild={true} boxSize={4} transform="rotate(180deg)"><LuIndentIncrease /></Icon>;
    $[7] = isNavPanelOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5 || $[12] !== t6) {
    t7 = <IconButton aria-label="Open Menu" bgColor={t2} borderRadius="md" boxShadow="none" size="sm" variant={t3} zIndex={96} _hover={t4} onClick={t5}>{t6}</IconButton>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [1, 1, 2];
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== activeContent.breadcrumbs) {
    let t10;
    if ($[17] !== activeContent.breadcrumbs.length) {
      t10 = (breadcrumb, index) => <React.Fragment key={index}><Breadcrumb.Item><Breadcrumb.Link asChild={true} _hover={{
            color: "colorPalette.fg",
            textDecoration: "none"
          }} letterSpacing="0.25" lineClamp={1} color={index === activeContent.breadcrumbs.length - 1 ? "colorPalette.fg" : "colorPalette.fg/60"}><NextLink href={breadcrumb.href}><Text color="colorPalette.fg" fontWeight="semibold" textStyle="sm">{breadcrumb.title || "..."}</Text></NextLink></Breadcrumb.Link></Breadcrumb.Item>{index < activeContent.breadcrumbs.length - 1 && <Breadcrumb.Separator />}</React.Fragment>;
      $[17] = activeContent.breadcrumbs.length;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    t9 = activeContent.breadcrumbs.map(t10);
    $[15] = activeContent.breadcrumbs;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <Box flexGrow={1}><Breadcrumb.Root color="colorPalette.fg"><Breadcrumb.List gap={t8}>{t9}</Breadcrumb.List></Breadcrumb.Root></Box>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isAsidePanelOpen || $[22] !== layout) {
    t11 = false && <Box><IconButton aria-label="Open Menu" bgColor={isAsidePanelOpen ? "backgroundTertiaryAlpha.300" : "actionActiveSecondary"} borderRadius="md" boxShadow="none" size="sm" variant={isAsidePanelOpen ? "solid" : "solid"} onClick={() => {
        layout.togglePanel("members-aside");
      }}>{isAsidePanelOpen ? <Icon asChild={true} boxSize={4} color="actionPrimaryAlpha.500"><LuIndentIncrease /></Icon> : <Icon asChild={true} boxSize={4} color="white"><PiChatCircleTextBold /></Icon>}</IconButton></Box>;
    $[21] = isAsidePanelOpen;
    $[22] = layout;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t7) {
    t12 = <HStack align="center" backdropFilter="blur(10px)" bgColor="colorPalette.container/70" boxShadow="xs" gap={4} height="56px" justify="flex-start" padding={3} position="sticky" top={0} width="full" zIndex={96}>{t7}{t10}{t11}</HStack>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t7;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};